// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"536d2f7b","178":"b3c114ba","386":"c6f7d44f","401":"c208769e","488":"774a843c","522":"e9a5f3dd","625":"30073b70","658":"50649de5","735":"bab70d56","797":"9002cede"}[chunkId] + ".js";
};